import * as React from 'react';
import { useEffect } from 'react';

export const GlassboxScript = () => {
  useEffect(() => {
    const scriptES6 = document.createElement('script');
    scriptES6.src = '//cdn.glassboxcdn.com/expedia/detector-dom.min.js';
    scriptES6.id = '_cls_detector';
    scriptES6.setAttribute('data-test-id', 'test-glassbox-script');
    scriptES6.setAttribute(
      'data-clsconfig',
      'reportURI=https://report.bex.glassboxdigital.io/glassbox/reporting/076D5FEA-F74F-D2EA-CE0B-C715FFB17434/cls_report;maskingMode=whitelist;maskClassList=gb-whitelist;recordScrolls=true;recordMouseMoves=true;valueAutoMasking=true'
    );
    scriptES6.defer = true;
    scriptES6.async = true;
    document.body.appendChild(scriptES6);

    return () => {
      document.body.removeChild(scriptES6);
    };
  }, []);

  return <></>;
};
